import { createAction } from '@reduxjs/toolkit'
import {
  grhType,
  micromobilityType,
  flexType,
  qtfType,
  transitPassType,
  couponType,
  reportedUsageType,
  CurrencyType,
} from '../Shared/types'
import { SegmentList } from '../Shared/helperFunctions'
import { Month } from 'shared/DateUtils'

const newEditCycleCleanup = createAction('programSuccess/newEditCycleCleanup')

const createQtfProgramForASegment = createAction<{
  qtf: qtfType
  segment: SegmentList
  selectedDate: Month
  currentUserId: string
  launchId: string
  superProgramName: string
}>('programSuccess/createQtfProgramForASegment')

const createBulkQtfProgramForASegmentList = createAction<{
  qtf: qtfType
  segmentIdList: string[]
  selectedDate: Month
  currentUserId: string
  launchId: string
  superProgramName: string
}>('programSuccess/createBulkQtfProgramForSegmentList')

const createGrhProgramForASegment = createAction<{
  grh: grhType
  segment: SegmentList
  selectedDate: Month
  merchantsMap: any
  launchId: string
  superProgramName: string
  currency?: CurrencyType
}>('programSuccess/createGrhProgramForASegment')

const createMicromobilityProgramForASegment = createAction<{
  micromobility: micromobilityType
  segment: SegmentList
  selectedDate: Month
  merchantsMap: any
  launchId: string
  superProgramName: string
  currency?: CurrencyType
}>('programSuccess/createMicromobilityProgramForASegment')

const createFlexProgramForASegment = createAction<{
  flex: flexType
  segment: SegmentList
  selectedDate: Month
  merchantsMap: any
  launchId: string
  superProgramName: string
  currency?: CurrencyType
}>('programSuccess/createFlexProgramForASegment')

const updateFlexProgramForASegment = createAction<{
  flex: flexType
  segment: SegmentList
  selectedDate: Month
  merchantsMap: any
  programId: string
  launchId: string
  superProgramName: string
  currency?: CurrencyType
}>('programSuccess/updateFlexProgramForASegment')

const createTransitPassProgramForASegment = createAction<{
  transitPass: transitPassType
  segment: SegmentList
  selectedDate: Month
  launchId: string
  superProgramName: string
  description?: string
  currency?: CurrencyType
}>('programSuccess/createTransitPassProgramForASegment')

const updateTransitPassProgramForASegment = createAction<{
  transitPass: transitPassType
  segment: SegmentList
  selectedDate: Month
  programId: string
  launchId: string
  superProgramName: string
  description?: string
  currency?: CurrencyType
}>('programSuccess/updateTransitPassProgramForASegment')

const cancelTransitPassProgramForASegment = createAction<{
  programId: string
}>('programSuccess/cancelTransitPassProgramForASegment')

const createCouponProgramForASegment = createAction<{
  coupon: couponType
  segment: SegmentList
  selectedDate: Month
  launchId: string
  superProgramName: string
  description?: string
  currency?: CurrencyType
}>('programSuccess/createCouponProgramForASegment')

const updateCouponProgramForASegment = createAction<{
  coupon: couponType
  segment: SegmentList
  selectedDate: Month
  programId: string
  launchId: string
  superProgramName: string
  description?: string
  currency?: CurrencyType
}>('programSuccess/updateCouponProgramForASegment')

const cancelCouponProgramForASegment = createAction<{
  programId: string
}>('programSuccess/cancelCouponProgramForASegment')

const createCouponProgramSuccess = createAction(
  'programSuccess/createCouponProgramSuccess'
)

const updateCouponProgramSuccess = createAction(
  'programSuccess/updateCouponProgramSuccess'
)

const cancelCouponProgramSuccess = createAction(
  'programSuccess/cancelCouponProgramSuccess'
)

const createReportedUsageProgramForASegment = createAction<{
  reportedUsage: reportedUsageType
  segment: SegmentList
  selectedDate: Month
  launchId: string
  superProgramName: string
  description?: string
  currency?: CurrencyType
}>('programSuccess/createReportedUsageProgramForASegment')

const updateReportedUsageProgramForASegment = createAction<{
  reportedUsage: reportedUsageType
  segment: SegmentList
  selectedDate: Month
  programId: string
  launchId: string
  superProgramName: string
  description?: string
  currency?: CurrencyType
}>('programSuccess/updateReportedUsageProgramForASegment')

const cancelReportedUsageProgramForASegment = createAction<{
  programId: string
}>('programSuccess/cancelReportedUsageProgramForASegment')

const createReportedUsageProgramSuccess = createAction(
  'programSuccess/createReportedUsageProgramSuccess'
)
const updateReportedUsageProgramSuccess = createAction(
  'programSuccess/updateReportedUsageProgramSuccess'
)
const cancelReportedUsageProgramSuccess = createAction(
  'programSuccess/cancelReportedUsageProgramSuccess'
)

const updateQtfProgramForASegment = createAction<{
  qtf: qtfType
  segment: SegmentList
  selectedDate: Month
  currentUserId: string
  typeMap: any
  launchId: string
  superProgramName: string
}>('programSuccess/updateQtfProgramForASegment')

const updateGrhProgramForASegment = createAction<{
  grh: grhType
  segment: SegmentList
  selectedDate: Month
  merchantsMap: any
  programId: string
  launchId: string
  superProgramName: string
  currency?: CurrencyType
}>('programSuccess/updateGrhProgramForASegment')

const updateMicromobilityProgramForASegment = createAction<{
  micromobility: micromobilityType
  segment: SegmentList
  selectedDate: Month
  merchantsMap: any
  programId: string
  launchId: string
  superProgramName: string
  currency?: CurrencyType
}>('programSuccess/updateMicromobilityProgramForASegment')

const cancelQtfProgramForASegment = createAction<{
  programIds: string[]
}>('programSuccess/cancelQtfProgramForASegment')

const cancelGrhProgramForASegment = createAction<{
  programId: string
}>('programSuccess/cancelGrhProgramForASegment')

const cancelMicromobilityProgramForASegment = createAction<{
  programId: string
}>('programSuccess/cancelMicromobilityProgramForASegment')

const cancelFlexProgramForASegment = createAction<{
  programId: string
}>('programSuccess/cancelFlexProgramForASegment')

export const programSuccessActions = {
  newEditCycleCleanup,
  createQtfProgramForASegment,
  createBulkQtfProgramForASegmentList,
  createGrhProgramForASegment,
  createMicromobilityProgramForASegment,
  createFlexProgramForASegment,
  updateFlexProgramForASegment,
  createTransitPassProgramForASegment,
  updateTransitPassProgramForASegment,
  cancelTransitPassProgramForASegment,
  createCouponProgramForASegment,
  updateCouponProgramForASegment,
  cancelCouponProgramForASegment,
  createReportedUsageProgramForASegment,
  updateReportedUsageProgramForASegment,
  cancelReportedUsageProgramForASegment,
  createReportedUsageProgramSuccess,
  updateReportedUsageProgramSuccess,
  cancelReportedUsageProgramSuccess,
  createCouponProgramSuccess,
  updateCouponProgramSuccess,
  cancelCouponProgramSuccess,
  updateQtfProgramForASegment,
  updateGrhProgramForASegment,
  updateMicromobilityProgramForASegment,
  cancelQtfProgramForASegment,
  cancelGrhProgramForASegment,
  cancelMicromobilityProgramForASegment,
  cancelFlexProgramForASegment,
  cancelTransitPassProgramForASegment,
}
